export default __webpack_public_path__ + "static/media/vit_hack.0659dc97.jpg";